<script setup lang="ts">
import {defineProps, ref, watch} from "vue";

const props = defineProps<{ length?: number }>();
const otp = defineModel<string>({type: String});
const otpLength = props.length ?? 4;
const values = ref<string[]>(Array(otpLength).fill(""));
const inputs = ref<HTMLInputElement[]>([]);
let emit = defineEmits(['onApplyClick']);

watch(
  () => otp.value,
  (val) => {
    if (val !== values.value.join("")) {
      values.value = val ? val.split("").slice(0, otpLength) : Array(otpLength).fill("");
    }
  },
  {immediate: true}
);

function emitValue() {
  otp.value = values.value.join("");
}

function onInput(e: Event, i: number) {
  const input = e.target as HTMLInputElement;
  const v = input.value.replace(/[^a-zA-Z0-9]/g, "").slice(-1);
  values.value[i] = v || "";
  emitValue();
  if (v && i < otpLength - 1) {
    inputs.value[i + 1]?.focus();
    inputs.value[i + 1]!.select();
  }
}

function onKeyDown(e: KeyboardEvent, i: number) {
  if (e.key === "Backspace" && !values.value[i] && i > 0) {
    inputs.value[i - 1]?.focus();
  }
}

function onApplyClick() {
  emit('onApplyClick');
}

function onPaste(e: ClipboardEvent, i: number) {
  e.preventDefault();
  if (i !== 0)
    return;
  const pasted = (e.clipboardData?.getData("text") ?? "").replace(/[^a-zA-Z0-9]/g, "");
  if (!pasted) return;
  const chars = pasted.slice(0, otpLength).split("");
  values.value = [...chars, ...Array(otpLength).fill("")].slice(0, otpLength);
  emitValue();
  inputs.value[Math.min(chars.length - 1, otpLength - 1)]?.focus();
}

function onFocus(e: Event) {
  (e.target as HTMLInputElement).select();
}
</script>

<template>
  <div class="tw-w-full tw-flex tw-gap-3 rtl:tw-flex-row-reverse tw-overflow-x-auto"
       :class="[otpLength > 6 ? 'tw-justify-start':'tw-justify-center']">
    <input
      v-for="(_, index) in otpLength" :key="index" ref="inputs" :value="values[index]" type="text" maxlength="1" inputmode="numeric"
      class="tw-w-12 tw-h-12 tw-text-center tw-border tw-rounded-lg tw-text-2xl tw-font-bold tw-text-gray-500 tw-caret-transparent
             tw-focus:ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500"
      @input="onInput($event, index)" @keydown="onKeyDown($event, index)" @focus="onFocus" @paste="onPaste($event, index)"
      @keydown.enter="onApplyClick"
    />
  </div>
</template>

<style scoped>

</style>
